/* unplugin-vue-components disabled */import { render } from "./Login.vue?vue&type=template&id=04ca5e4d&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=04ca5e4d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-04ca5e4d"

export default script